const web_index = () => import(/* webpackChunkName: "web" */ '../web/web/index');
const web_moble = () => import(/* webpackChunkName: "web" */ '../web/web/moble')
const web_Template1 = () => import(/* webpackChunkName: "web" */ '../web/preview/Template1/index');
const web_Template1_list = () => import(/* webpackChunkName: "web" */ '../web/preview/Template1/list');
const web_Template1_details = () => import(/* webpackChunkName: "web" */ '../web/preview/Template1/details');
const web_Template2 = () => import(/* webpackChunkName: "web" */ '../web/preview/Template2/index');
const web_Template2_list = () => import(/* webpackChunkName: "web" */ '../web/preview/Template2/list');
const web_Template2_details = () => import(/* webpackChunkName: "web" */ '../web/preview/Template2/details');
const wap_mTemplateb_detail = () => import(/* webpackChunkName: "web" */ '../web/preview/mTemplateb/detail.vue')
const wap_mTemplatea_detail = () => import(/* webpackChunkName: "web" */ '../web/preview/mTemplatea/detail.vue')
const wap_mTemplatea_list = () => import(/* webpackChunkName: "web" */ '../web/preview/mTemplatea/list.vue')
const wap_mTemplateb_list = () => import(/* webpackChunkName: "web" */ '../web/preview/mTemplateb/list.vue')

var web_router = [
    {
      path: '/web/web/index',
      name: '/web/web/index',  //预览模板 - 入口
      component: web_index,
      meta: { title: '预览模板', name: 'viewport', content: "width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no" },
    },
    {
      path: '/web/web/moble',
      name: '/web/web/moble', //预览模板 - 入口
      component: web_moble,
      meta: {
        title: '预览模板',
        name: 'viewport',
        content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    },
    {
      path: '/web/preview/Template1/index',
      name: '/web/preview/Template1/index',  //预览模板1 - 首页
      component: web_Template1,
      meta: { title: '首页', name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },{
      path: '/web/preview/Template1/list',
      name: '/web/preview/Template1/list',  //预览模板1 - 列表
      component: web_Template1_list,
      meta: { title: '列表', name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },{
      path: '/web/preview/Template1/details',
      name: '/web/preview/Template1/details',  //预览模板1 - 详情
      component: web_Template1_details,
      meta: { title: '详情', name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },{
      path: '/web/preview/Template2/index',
      name: '/web/preview/Template2/index',  //预览模板2 - 首页
      component: web_Template2,
      meta: { title: '首页', name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },{
      path: '/web/preview/Template2/list',
      name: '/web/preview/Template2/list',  //预览模板2 - 列表
      component: web_Template2_list,
      meta: { title: '列表', name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },{
      path: '/web/preview/Template2/details',
      name: '/web/preview/Template2/details',  //预览模板2 - 详情
      component: web_Template2_details,
      meta: { title: '详情', name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },
    
  {
    path: '/web/preview/mTemplateb/detail',
    name: '/web/preview/mTemplateb/detail', //预览模板1 - 详情
    component: wap_mTemplateb_detail,
    meta: {
      title: '详情',
      name: 'viewport',
      content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
    }
  },
  {
    path: '/web/preview/mTemplatea/detail',
    name: '/web/preview/mTemplatea/detail', //预览模板1 - 详情
    component: wap_mTemplatea_detail,
    meta: {
      title: '详情',
      name: 'viewport',
      content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
    }
  },
  {
    path: '/web/preview/mTemplatea/list',
    name: '/web/preview/mTemplatea/list', //预览模板1 - 详情
    component: wap_mTemplatea_list,
    meta: {
      title: '详情',
      name: 'viewport',
      content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
    }
  },
  {
    path: '/web/preview/mTemplateb/list',
    name: '/web/preview/mTemplateb/list', //预览模板1 - 详情
    component: wap_mTemplateb_list,
    meta: {
      title: '详情',
      name: 'viewport',
      content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
    }
  },
];
export {
  web_router
}



// WEBPACK FOOTER //
// ./src/web/router/index.js